module.exports = __webpack_public_path__ + "img/w_bg.94af0417.png";